import Icon from "@material-ui/icons/Person";
import AcademicYearCreate from "./AcademicYearCreate";
import AcademicYearEdit from "./AcademicYearEdit";
import AcademicYearShow from "./AcademicYearShow";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "academicYears",
  show: AcademicYearShow,
  edit: AcademicYearEdit,
  create: AcademicYearCreate,
  icon: Icon,
};
